<div>
  <app-loading-overlay-full *ngIf="loading"></app-loading-overlay-full>
  <a (click)="activeModal.close()" class="rounded-4 bg-danger text-white icon-btn modal-close-icon">
    <i class="fs-4 bi bi-x fw-bold"></i>
  </a>
  <div class="w-100 mb-2">
    <div class="row">
      <div class="col-md-12">
        <div class="card-body">
          <div class="col-lg-12 p-0 m-0 text-center">
            <div class="w-100 px-3 pb-1 pt-3 d-flex justify-content-center">
              <div class="camera-widget" ngbAutofocus>
                <webcam [allowCameraSwitch]="true" [width]="465" [ngClass]="'rounded-0'" [trigger]="trigger"
                  [trigger]="triggerObservable" [videoOptions]="videoOptions" (imageCapture)="handleImage($event)">
                </webcam>
              </div>
            </div>
            <div class="px-3 pt-2 border-top d-flex justify-content-center">
              <button (click)="triggerSnapshot()"
                class="btn btn-lg btn-dark text-center w-100 d-flex justify-content-center">
                <span><i class="bi bi-person-check-fill fw-semibold me-2"></i> Verify Member</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
